import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { useAuthStore } from "@/store/auth.store";
import { authHeader } from "@roman/shared/lib/auth/authHeader";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const DeleteMe = () => {
  const [confirmText, setConfirmText] = useState("");
  const { deleteMe } = useAuthStore();
  const navigate = useNavigate();

  const handleDeleteMe = async () => {
    await deleteMe(authHeader.getOrThrow());
    navigate("/login");
  };

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="flex flex-col min-h-[calc(100vh-72px)] p-4 sm:px-8">
        <div className="text-lg font-bold leading-normal tracking-tight mt-5">退会申請</div>
        <div className=" mt-[20px] mb-[30px]">
          <div className="text-lg font-bold leading-normal tracking-tight">退会申請をします</div>
          <div className="mt-[10px] text-black text-sm font-medium tracking-tight">
            このページより退会申請をすると、1週間の猶予期間の後にアカウントが完全に削除されます。
            <span className="text-primary"> 猶予期間内に再度ログインする</span> と、その時点で退会申請が取り消されます。
          </div>
        </div>
        <div className="text-lg font-bold leading-normal tracking-tight">本当に退会しますか？</div>
        <div className="mt-[10px] text-black text-sm font-medium tracking-tight mb-[36px]">
          1週間の猶予期間を経過し、アカウントが削除されると、保有するコインが消滅します。また、
          <span className="text-red"> 一度アカウントが削除されると復旧することはできません</span>{" "}
          。それでも削除する場合は、以下のフォームに「削除」と入力してボタンをタップしてください。
        </div>
        <div className="flex justify-center items-center">
          <div className="w-[500px]">
            <input
              type="text"
              placeholder="削除"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full p-3 border border-input rounded-lg focus:outline-none focus:border-primary mb-[28px]"
            />
            <PrimaryButton text="退会する" onClick={handleDeleteMe} disabled={confirmText !== "削除"} />
          </div>
        </div>
      </div>
    </div>
  );
};
